/* Hvilo – tema-JS (vanilla). Händelsedelegering, så att allt fungerar även när
   temaredigeraren laddar om en sektion. */
(function () {
  'use strict';

  /* ---------- Hitta din vila: val av område → produktförslag ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hv-area]');
    if (!btn) return;
    var root = btn.closest('[data-hv-finder]');
    if (!root) return;
    root.querySelectorAll('[data-hv-area]').forEach(function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });
    var name = root.querySelector('[data-hv-rec-name]');
    var text = root.querySelector('[data-hv-rec-text]');
    var cta = root.querySelector('[data-hv-rec-cta]');
    if (name) name.textContent = btn.dataset.name;
    if (text) text.textContent = btn.dataset.text;
    if (cta) {
      cta.textContent = btn.dataset.cta;
      cta.setAttribute('href', btn.dataset.href || '#');
      cta.dataset.live = btn.dataset.live;
    }
  });

  /* Piltangenter i radiogruppen */
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hv-area]');
    if (!btn || ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
    var all = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-hv-area]'));
    var i = all.indexOf(btn) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    var next = all[(i + all.length) % all.length];
    e.preventDefault();
    next.focus();
    next.click();
  });

  /* ---------- Lägesväljare (produktsidan) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hv-mode]');
    if (!btn) return;
    var root = btn.closest('[data-hv-modes]');
    root.querySelectorAll('[data-hv-mode]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    root.querySelector('[data-hv-mode-name]').textContent = btn.dataset.name;
    root.querySelector('[data-hv-mode-text]').textContent = btn.dataset.text;
  });

  /* ---------- Paketval → antal i varukorgen ---------- */
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-hv-bundle]');
    if (!r) return;
    document.querySelectorAll('[data-hv-quantity]').forEach(function (q) { q.value = r.value; });
  });

  /* ---------- Miniatyrer → scenbild ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hv-thumb]');
    if (!btn) return;
    var root = btn.closest('[data-hv-product]');
    root.querySelectorAll('[data-hv-thumb]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var def = root.querySelector('[data-hv-stage-default]');
    var alt = root.querySelector('[data-hv-stage-alt]');
    if (!def || !alt) return;
    if (btn.hasAttribute('data-default') || !btn.dataset.src) {
      if (!btn.hasAttribute('data-default')) return; // platshållare utan bild
      alt.hidden = true;
      alt.innerHTML = '';
      def.hidden = false;
      return;
    }
    var img = new Image();
    img.src = btn.dataset.src;
    img.alt = btn.dataset.alt || '';
    alt.innerHTML = '';
    alt.appendChild(img);
    def.hidden = true;
    alt.hidden = false;
  });

  /* ---------- Varianter ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{amount}} kr';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(placeholder);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-hv-option]');
    if (!input) return;
    var root = input.closest('[data-hv-product]');
    var jsonEl = root && root.querySelector('[data-hv-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var selected = [];
    root.querySelectorAll('[data-hv-option]:checked').forEach(function (r) {
      selected[Number(r.dataset.hvOption)] = r.value;
    });
    var variant = data.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
    var price = root.querySelector('[data-hv-price]');
    var compare = root.querySelector('[data-hv-compare]');
    var sticky = document.querySelector('[data-hv-sticky-price]');
    document.querySelectorAll('[data-hv-variant-id]').forEach(function (el) {
      if (variant) el.value = variant.id;
    });
    document.querySelectorAll('[data-hv-atc]').forEach(function (b) {
      var ok = variant && variant.available;
      b.disabled = !ok;
      b.textContent = ok ? (b.dataset.addLabel || data.addLabel) : data.soldOutLabel;
    });
    if (!variant) return;
    var p = formatMoney(variant.price, data.moneyFormat);
    if (price) price.textContent = p;
    if (sticky) sticky.textContent = p;
    if (compare) {
      var has = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !has;
      if (has) compare.innerHTML = '<s>' + formatMoney(variant.compare_at_price, data.moneyFormat) + '</s>';
    }
    if (variant.featured_media) {
      var match = root.querySelector('[data-hv-thumb][data-media-id="' + variant.featured_media.id + '"]');
      if (match) match.click();
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });

  /* ---------- Menypanel (mobil) ---------- */
  function setMenu(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    if (open) {
      var header = btn.closest('header');
      var top = header ? header.getBoundingClientRect().bottom : 0;
      panel.style.setProperty('--hv-menu-top', Math.max(0, top) + 'px');
    }
    document.querySelectorAll('[data-hv-menu-toggle][aria-controls="' + panel.id + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Stäng meny' : 'Öppna meny');
    });
    panel.hidden = !open;
    document.documentElement.classList.toggle('hv-lock', open);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hv-menu-toggle]');
    if (!btn) return;
    setMenu(btn, btn.getAttribute('aria-expanded') !== 'true');
  });

  /* ---------- Varukorgslåda ---------- */
  var lastFocus = null;
  function cartEl() { return document.querySelector('[data-hv-cart]'); }
  function openCart() {
    var c = cartEl(); if (!c) return false;
    lastFocus = document.activeElement;
    document.querySelectorAll('[data-hv-menu-toggle][aria-expanded="true"]').forEach(function (b) { setMenu(b, false); });
    c.hidden = false;
    requestAnimationFrame(function () { c.classList.add('is-open'); var d = c.querySelector('[data-hv-cart-dialog]'); if (d) d.focus(); });
    document.documentElement.classList.add('hv-lock');
    return true;
  }
  function closeCart() {
    var c = cartEl(); if (!c || c.hidden) return;
    c.classList.remove('is-open');
    document.documentElement.classList.remove('hv-lock');
    setTimeout(function () { c.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderCart(html, count) {
    var c = cartEl(); if (!c || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hv-cart-dialog]');
    var dialog = c.querySelector('[data-hv-cart-dialog]');
    if (fresh && dialog) dialog.innerHTML = fresh.innerHTML;
    if (typeof count === 'number') {
      document.querySelectorAll('[data-hv-cart-count]').forEach(function (el) { el.textContent = count; });
    }
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-hv-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hv-cart-open]')) {
      if (openCart()) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-hv-cart-close]')) { closeCart(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    document.querySelectorAll('[data-hv-menu-toggle][aria-expanded="true"]').forEach(function (b) { setMenu(b, false); b.focus(); });
  });

  // Lägg i varukorgen utan sidladdning
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hv-product-form], [data-hv-sticky-form]');
    if (!form || !cartEl()) return;
    e.preventDefault();
    if (window.HV_PREVIEW) { openCart(); return; }
    var btn = form.querySelector('[data-hv-atc]'); if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) { renderCart(data.sections && data.sections['cart-drawer']); return refreshCount(); })
      .then(function () { openCart(); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Något gick fel. Försök igen.'); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  // Ändra antal / ta bort
  function changeLine(line, qty) {
    var c = cartEl(); if (!c) return;
    if (window.HV_PREVIEW) {
      var li = c.querySelector('[data-hv-line="' + line + '"]');
      if (!li) return;
      if (qty <= 0) { li.remove(); return; }
      li.querySelector('[data-hv-qty-input]').value = qty;
      li.querySelectorAll('[data-hv-qty]').forEach(function (b, i) { if (b.classList.contains('hv-qty__btn')) b.dataset.hvQty = i === 0 ? qty - 1 : qty + 1; });
      return;
    }
    c.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data.sections && data.sections['cart-drawer'], data.item_count); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { c.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hv-cart] [data-hv-qty]');
    if (!b) return;
    var li = b.closest('[data-hv-line]');
    changeLine(Number(li.dataset.hvLine), Math.max(0, Number(b.dataset.hvQty)));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-hv-cart] [data-hv-qty-input]');
    if (!input) return;
    changeLine(Number(input.closest('[data-hv-line]').dataset.hvLine), Math.max(0, parseInt(input.value, 10) || 0));
  });
})();

/* Produktgalleri (samma beteende som Nord Collagen) */
(function () {
  document.querySelectorAll('[data-hv-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-hv-gal-main]');
    var slides = gal.querySelectorAll('[data-hv-gal-slide]');
    var thumbs = gal.querySelectorAll('[data-hv-gal-thumb]');
    var swipe = window.matchMedia('(max-width: 899px)');
    function show(i) {
      thumbs.forEach(function (b) { b.setAttribute('aria-current', b.dataset.index === i ? 'true' : 'false'); });
      slides.forEach(function (s) { s.classList.toggle('is-on', s.dataset.index === i); });
    }
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.dataset.index;
        if (swipe.matches && main && main.clientWidth) main.scrollTo({ left: main.clientWidth * Number(i), behavior: 'smooth' });
        show(i);
      });
    });
    if (main) {
      var busy = false;
      main.addEventListener('scroll', function () {
        if (!swipe.matches || busy) return;
        busy = true;
        requestAnimationFrame(function () {
          busy = false;
          var w = main.clientWidth; if (!w) return;
          var i = String(Math.round(main.scrollLeft / w));
          var t = gal.querySelector('[data-hv-gal-thumb][data-index="' + i + '"]');
          if (t && t.getAttribute('aria-current') !== 'true') show(i);
        });
      }, { passive: true });
    }
  });
})();

/* Meddelanderaden: på smala skärmar visas ett meddelande i taget och byts var 4:e sekund */
(function () {
  document.querySelectorAll('.hv-announce--spread').forEach(function (el) {
    var items = Array.prototype.slice.call(el.children);
    if (items.length < 2) return;
    var i = 0;
    el.classList.add('is-js');
    items[0].classList.add('is-on');
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4000);
  });
})();
